import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'nonExecDirectorChangess/FETCH_REQUEST'
const FETCH_SUCCESS = 'nonExecDirectorChangess/FETCH_SUCCESS'
const FETCH_FAILURE = 'nonExecDirectorChangess/FETCH_FAILURE'
const FILTER_REQUEST = 'nonExecDirectorChangess/FILTER_REQUEST'
const FILTER_SUCCESS = 'nonExecDirectorChangess/FILTER_SUCCESS'
const FILTER_FAILURE = 'nonExecDirectorChangess/FILTER_FAILURE'
const FETCH_ALL_REQUEST = 'nonExecDirectorChangess/FETCH_ALL_REQUEST'
const FETCH_ALL_SUCCESS = 'nonExecDirectorChangess/FETCH_ALL_SUCCESS'
const FETCH_ALL_FAILURE = 'nonExecDirectorChangess/FETCH_ALL_FAILURE'

const initialState = {
  result: [],
  total_size: 0,
  loaded: false,
  loading: false,
  filterLoaded: false,
  filterLoading: false,
  allResult: [],
  allLoaded: false,
  allLoading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function filterRequest(payload = {}){
  return {
    type: FILTER_REQUEST
  }
}

export function filterSuccess(payload){
  return {
    type: FILTER_SUCCESS,
    payload
  }
}

export function filterFailure(errors = []){
  return {
    type: FILTER_FAILURE,
    errors
  }
}

export function fetchAllRequest(payload = {}){
  return {
    type: FETCH_ALL_REQUEST
  }
}

export function fetchAllSuccess(payload){
  return {
    type: FETCH_ALL_SUCCESS,
    payload
  }
}

export function fetchAllFailure(errors = []){
  return {
    type: FETCH_ALL_FAILURE,
    errors
  }
}

export function loadNonExecDirectorChanges(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('api/v1/non_exec_director_changes/', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

export function filterNonExecDirectorChanges(options = {}) {
  return (dispatch) => {
    dispatch(filterRequest())

    const promise = api('api/v1/non_exec_director_changes/', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(filterSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(filterFailure(errors))
        })
      })

    return promise
  }
}

export function loadAllNonExecDirectorChanges(options = {}) {
  return (dispatch) => {
    dispatch(fetchAllRequest())

    const promise = api('api/v1/non_exec_director_changes/', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchAllSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchAllFailure(errors))
        })
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload.result,
        total_size: payload.total_size
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    case FILTER_REQUEST:
      return Object.assign({}, state, {
        filterLoading: true
      });
    case FILTER_SUCCESS:
      return Object.assign({}, state, {
        filterLoading: false,
        filterLoaded: true,
        errors: [],
        result: payload.result,
        total_size: payload.total_size
      });
    case FILTER_FAILURE:
      return Object.assign({}, state, {
        filterLoaded: false,
        filterLoading: false,
        errors
      });
    case FETCH_ALL_REQUEST:
      return Object.assign({}, state, {
        fetchAllLoading: true
      });
    case FETCH_ALL_SUCCESS:
      return Object.assign({}, state, {
        fetchAllLoading: false,
        fetchAllLoaded: true,
        errors: [],
        allResult: payload.result
      });
    case FETCH_ALL_FAILURE:
      return Object.assign({}, state, {
        fetchAllLoaded: false,
        fetchAllLoading: false,
        errors
      });
    default:
      return state
  }
}

